module.exports = __webpack_public_path__ + "static/img/active_08.12266e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_08.jpg
// module id = 7QJS
// module chunks = 0